<div class="app-selector d-flex flex-column">
    <h4 class="text-center mb-4">Select Product</h4>
    <div class="d-flex gap-3 align-items-center" [ngClass]="isMobile ? 'flex-column justify-content-center' : 'flex-row flex-wrap justify-content-center'">
        <div class="appCard d-flex flex-column p-3 w-100" [style]="{borderWidth: '1px'}" *ngFor="let app of availableApps; let i = index" (click)="switchApp(app)">
            <div class="d-flex flex-row justify-content-between align-items-center">
                <div class="d-flex align-items-center gap-3">
                    <div class="icon" [innerHTML]="app.svg"></div>
                    <h6 class="fw-bold m-0">{{app.name}}</h6>
                </div>
                <div *ngIf="subscriptionState.selectedApp | fn : getIsSelected : app.type ">
                    ✅
                </div>
            </div>
            <hr>
            <span style="font-weight: 500; font-size: 14px;" class="text-muted">{{app.description}}</span>
        </div>
    </div>
    <div class="d-flex flex-row align-items-center mt-3 justify-content-between"> 
        <dx-button
            text="Back"
            icon="arrowleft"
            type="normal"
            (onClick)="this.backTriggered.emit();">
        </dx-button>
        <dx-button
            text="Next" 
            icon="arrowright"
            [rtlEnabled]="true"
            [disabled]="!subscriptionState.selectedApp"
            [elementAttr]="{class: 'next-button'}"
            type="default"
            (onClick)="this.nextTriggered.emit();">
        </dx-button>
    </div>
</div>